export default "__VITE_PUBLIC_ASSET__90a8fd91__"